import { Either, left, right } from "fp-ts/lib/Either";
import QAAgentEntity from "../../../../domain/entities/qa_agent.entity";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QAQuestionDto from "../../../dto/qa_question.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const createAgentApiImpl = async (formData: FormData):
    Promise<Either<ErrorEntity, QAAgentEntity>> => {
    try {
        const relativeUrl = "/agent";
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, formData);
        const parsed = new QAAgentEntity({
            id: response.agent_id,
            name: response.agent_name,
            description: response.description,
            flexibility: response.flexibility,
            clientId: response.clientId,
            categories: [],
            files: [],
            assistant_id: response.assistant_id ?? '',
            vector_store_id: response.vector_store_id ?? '',
            is_assistant: response.is_assistant ?? false,
        });
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default createAgentApiImpl;